/**
 * Ralph & Doug peeks (snippets/rd-peeks.liquid): Ralph leans in from the left edge, Doug
 * slides in from the right and pops up from the bottom. Ported from startseite.html in the
 * prototype. Two triggers:
 * - scroll progress: each stop in STOPS fires once when the page has been scrolled that far;
 * - idle time: after IDLE_MS without scrolling, one of them (taking turns) peeks in.
 * Only one peek at a time, at least MIN_GAP apart, never during the world transition, never
 * while the book or the bundle box holds the screen and never while a drawer or dialog is open.
 * A stop reached while blocked fires once it is free. Reduced motion: no peeks at all.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var STOPS = [
    { who: 'ralph', at: 0.18 },
    { who: 'doug', at: 0.38 },
    { who: 'ralph', at: 0.6 },
    { who: 'dougLow', at: 0.82 }
  ];
  var IDLE_ORDER = ['ralph', 'doug', 'dougLow'];
  var IDLE_MS = 9000;
  var MIN_GAP = 6000;
  var STAGE_SHARE = 0.4;
  var OPEN_LAYERS = 'dialog[open], x-drawer[open], x-modal[open], cart-drawer[open], cart-notification-drawer[open]';

  var peeks = {};
  var busy = false;
  var lastEnd = -Infinity;
  var idleTurn = 'ralph';
  var idleTimer = null;
  var leave = null;
  var stops = STOPS.map(function (s) { return { who: s.who, at: s.at, done: false }; });

  var progress = function () {
    var max = root.scrollHeight - window.innerHeight;
    return max > 0 ? window.scrollY / max : 0;
  };

  // The book and the bundle box are scroll stages; a peek over them would cover the show.
  var stageOnScreen = function () {
    var vh = window.innerHeight;
    var stages = document.querySelectorAll('.rd-flip, .rd-bundle');
    for (var i = 0; i < stages.length; i++) {
      var r = stages[i].getBoundingClientRect();
      if (Math.min(r.bottom, vh) - Math.max(r.top, 0) > vh * STAGE_SHARE) return true;
    }
    return false;
  };

  var blocked = function () {
    if (root.classList.contains('rd-wt-run') || root.classList.contains('rd-wt-covered')) return true;
    if (document.querySelector(OPEN_LAYERS)) return true;
    return stageOnScreen();
  };

  // The top edge of what the bar actually paints right under Doug (between left and right).
  // On the phone the bar itself is transparent with 20px of padding and only its button shows;
  // on the desktop it is a card in the bottom right corner while Doug comes up on the left. In
  // both cases the bar's own box lifted him into thin air (user, 2026-10-10).
  var paintedTop = function (bar, left, right) {
    var top = Infinity;
    var nodes = [bar].concat(Array.prototype.slice.call(bar.querySelectorAll('*')));
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.height <= 0 || r.width <= 0) continue;
      if (r.right <= left || r.left >= right) continue;
      var cs = getComputedStyle(nodes[i]);
      var painted = !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)|transparent/.test(cs.backgroundColor) ||
        (parseFloat(cs.borderTopWidth) > 0 && cs.borderTopStyle !== 'none');
      if (painted && r.top < top) top = r.top;
    }
    return top;
  };

  // Doug from below stands on the sticky add-to-cart bar instead of behind it.
  var placeLow = function (el) {
    var bar = document.querySelector('.product-quick-add');
    var offset = 0;
    if (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight && getComputedStyle(bar).visibility !== 'hidden') {
        var own = el.getBoundingClientRect();
        var top = paintedTop(bar, own.left, own.right);
        if (top < window.innerHeight) offset = Math.max(0, window.innerHeight - top);
      }
    }
    el.style.setProperty('--rd-peek-bottom', offset + 'px');
  };

  var check = function () {
    var p = progress();
    for (var i = 0; i < stops.length; i++) {
      var stop = stops[i];
      if (!stop.done && p >= stop.at) {
        if (peek(stop.who)) stop.done = true;
        return;
      }
    }
  };

  var peek = function (who) {
    var el = peeks[who];
    if (!el || busy || blocked() || performance.now() - lastEnd < MIN_GAP) return false;
    if (who === 'dougLow') placeLow(el);
    busy = true;
    el.classList.add('is-peeking');
    var done = function (event) {
      if (event && event.target !== el) return;
      el.removeEventListener('animationend', done);
      el.classList.remove('is-peeking');
      busy = false;
      leave = null;
      lastEnd = performance.now();
      check();
    };
    el.addEventListener('animationend', done);
    leave = done;
    return true;
  };

  var armIdle = function () {
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(function () {
      if (peek(idleTurn)) idleTurn = IDLE_ORDER[(IDLE_ORDER.indexOf(idleTurn) + 1) % IDLE_ORDER.length];
      armIdle();
    }, IDLE_MS);
  };

  var onScroll = function () {
    armIdle();
    // A stage or a drawer took the screen mid-peek: send the figure off right away.
    if (busy && leave && blocked()) {
      leave();
      return;
    }
    check();
  };

  // The images load only after the page itself, so the peeks never compete with it.
  var loadImages = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.rd-peek img[data-src]'), function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  };

  var init = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rd-peek]'), function (el) {
      peeks[el.getAttribute('data-rd-peek')] = el;
    });
    if (!peeks.ralph && !peeks.doug && !peeks.dougLow) return;
    loadImages();
    window.addEventListener('scroll', onScroll, { passive: true });
    armIdle();
    check();
  };

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();
